module.exports = __webpack_public_path__ + "img/thumb_28.28d4a48a.jpg";